import { FC } from 'react';

import { Box } from '@mui/material';

import { ContentWrapper } from 'components/_basic/ContentWrapper/ContentWrapper';
import { Loader } from 'components/_basic/Loader/Loader';
import { RadioGroup } from 'components/_basic/RadioGroup/RadioGroup';

import { IViewProps } from './types';

import styles from './OnePageTypeSwitch.module.scss';

export const DesktopView: FC<IViewProps> = ({ isPending, value, onChange, options }) => {
  return (
    <ContentWrapper className={styles.wrapper}>
      {isPending ? (
        <Box className={styles.loaderWrapper}>
          <Loader size={30} />
        </Box>
      ) : (
        <RadioGroup value={value} onChange={onChange} options={options} />
      )}
    </ContentWrapper>
  );
};
